import type { SVGProps } from 'react';
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M21.544 6.044 12 15.585 2.456 6.044 1.04 7.46l10.25 10.25a.999.999 0 0 0 1.412 0l10.25-10.25-1.409-1.416z" />
  </svg>
);
export default SvgChevronDown;
